import * as signalR from "@microsoft/signalr";
import { toast } from "react-toastify";

let connection: signalR.HubConnection | null = null;

export const startSignalRConnection = async () => {
  if (connection) return connection;

  connection = new signalR.HubConnectionBuilder()
    .withUrl("https://api.wocons.com:8443/notificationHub", {
      accessTokenFactory: () => sessionStorage.getItem("token") || ""
    })
    .withAutomaticReconnect()
    .build();

  try {
    await connection.start();
    //toast.success("SignalR Global Connected");
  } catch (err:any) {
    toast.error("SignalR Start Error:", err);
  }

  return connection;
};

export const getSignalRConnection = () => connection;